

import { Component, OnInit } from '@angular/core';
import {Inject} from '@angular/core';
import { ProjectService } from 'src/app/Services/project.services'; 
import { Materials } from 'Materials';
import { Project, ProjectMaterial } from 'src/app/objects/Project';

import { MatTableDataSource } from '@angular/material/table'; 
import { ProjectMaterialService } from 'src/app/Services/projectMaterials';
import { ActivatedRoute, Router } from '@angular/router';
import { MaterialsService } from 'src/app/Services/materials.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';;

import { ProjectTask } from 'src/app/objects/Project';
@Component({
  selector: 'app-project-task-add',
  templateUrl: './project-task-add.component.html',
  styleUrls: ['./project-task-add.component.css']
})
export class ProjectTaskAddComponent implements OnInit {

  

  ProjectId: number | undefined ;
  project: Project |any;
  searchTerm: string = '';
  isLoadingResults: boolean | undefined; 
  showAvailbleMaterials: boolean | undefined; 

  items: any[] = [];
  materials: Materials []=[];
  // ProjectMaterials: ProjectMaterial []=[];
  sortProperty: string = 'id';
  sortOrder = 1;
  sortListProperty: string = 'id';
  sortListOrder = 1;
  ProjectObject?: Project []=[];

  durationInSeconds = 5;
  constructor( private route: ActivatedRoute,  private router: Router,
    private materialsService: MaterialsService,
    private projectMaterialService: ProjectMaterialService,
    private projectService: ProjectService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<ProjectTaskAddComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
    
    ) {  
     } 

  ngOnInit(): void { 
 

      if (this.data != undefined) {
      
        this.loadProject(this.data.projectId);
      }
      this.loadTasks();
    }
  
    loadTasks() {
      this.materialsService.GetMaterials().subscribe((materials) => {
        this.materials = materials;
        console.log(materials);
        
      });
    }
 
 
  today!: Date;

  newProjectTask: ProjectTask = {
    id: 0,
    title: '',
    description: '',
    dueDate: this.today,
    assignedTo: '',
    completed:false
  };
 
  onSubmit() {   
    
  this.addTaskToProjectTasks(this.newProjectTask);
  }

   

  addTaskToProjectTasks(task:ProjectTask)
  { 
    let newProjectTask: ProjectTask  = Object.assign(task); 
    let newProject: Project   = Object.assign({}, this.project); 

    //Go Back and Fix
    newProjectTask.id = 0 ; //= newProject.id;
    newProjectTask.title = task.title;
    newProjectTask.description = task.description;
    newProjectTask.dueDate = task.dueDate;
    newProjectTask.assignedTo = task.assignedTo;
    newProjectTask.completed = task.completed; 
     //console.log(this.name,this.empoloyeeID);
   
  //  newProject.materials = newProject.materials || [];


  // // Update data source with edited values
  // let tasks: ProjectTask[]= this.project.projectTasks;
  // if(task != undefined)
  // {
  // tasks.push(newProjectTask);
  // }
  // else
  // {
  //   task.fill(newProjectTask);
  // }
  //     //|ProjectTask []= projecttas.materials 
  //     newProject.projectTasks = tasks;



    //  if(newProject.projectTasks == null)
    // {
    //   let tasks: ProjectTask[] | any; 
    //   tasks.push(newProjectTask);

    //   //|ProjectTask []= projecttas.materials 
    //   newProject.projectTasks = tasks;
  
    // }  
    // else{
       
    newProject.projectTasks = newProject.projectTasks || [];
     newProject.projectTasks.push(newProjectTask);
    // }
//newProject.projectTasks = tasks

    this.projectService.updateProject(newProject)
    .subscribe(res => {
       
        // Simple message.
        this.openSnackBar();
        this.isLoadingResults = false;
        console.log('Project edited successfully!');
        this.loadProject(this.project?.id);

        this.reLoad();

        this.dialogRef.close();
      }, (err) => {
        console.log(err);
        this.isLoadingResults = false;
      });
  }

  reLoad(){
    this.router.navigate([this.router.url])
  }

  openSnackBar() {
 
    this.snackBar.open('Successfully Updated Task on Project', '', {
      duration: 3000
    });
  }
 
  getTotalCost(newProject: Project)
  {
  
    const sum = newProject.materials.reduce((accumulator, object) => {
      return accumulator + object.cost;
    }, 0);
    return sum;
  }

  loadProject(projectId: number) {
  
    this.projectService.getProject(projectId).subscribe((project) => {
      this.project = project;
     
        
    });
 
  }

  sortBy(property: string) {
     
    this.sortOrder = property === this.sortProperty ? (this.sortOrder * -1) : 1;
    this.sortProperty = property;
    this.items = [...this.materials.sort((a: any, b: any) => {
        // sort comparison function
        let result = 0;
        if (a[property] < b[property]) {
            result = -1;
        }
        if (a[property] > b[property]) {
            result = 1;
        }
        return result * this.sortOrder;
    })];
}


  sortIcon(property: string) {
    if (property === this.sortProperty) {
        return this.sortOrder === 1 ? '☝️' : '👇';
    }
    return '';
}
}
